export const SITE = {
  name: "SVG Multimídia",
  tagline: "SEO, sites e otimização de Ficha do Google para empresas",
  description:
    "SVG Multimídia: criação de sites com SEO, otimização de Ficha do Google e estratégias orgânicas para transformar buscas em clientes reais.",
  baseUrl: "https://www.svgmultimidia.com.br",
  whatsappNumber: "5555991438702",
  whatsappMessage: "Olá quero saber mais sobre o CRM SVG",
  email: "svgmultimidia@gmail.com",
  phoneDisplay: "(55) 99143-8702",
  social: {
    instagram: "https://www.instagram.com/svgmultimidia/",
    youtube: "https://www.youtube.com/@mariojorge_mkt",
    youtubeSvg: "https://www.youtube.com/@svgmultimidiabr",
    facebook: "https://www.facebook.com/profile.php?id=61561513733074",
  },
};

export const CONTACT_URL = "https://pixel.agendasistemacrm.com.br/r/qxgushz";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const whatsappUrl = (_msg?: string) => CONTACT_URL;

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/otimizacao-ficha-google", label: "Ficha do Google" },
  { to: "/criacao-de-sites", label: "Criação de Sites" },
  { to: "/seo-local", label: "SEO Local" },
  { to: "/seo-nacional", label: "SEO Nacional" },
  { to: "/plano-autoridade-local", label: "Autoridade Local" },
  { to: "/crm-yt", label: "CRM SVG" },
  { to: "/crm-para-whatsapp", label: "CRM WhatsApp" },
  { to: "/blog", label: "Blog" },
  { to: "/academia", label: "Academia" },
  { to: "/sobre", label: "Sobre" },
  { to: "/contato", label: "Contato" },
] as const;